/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from "layouts/pages/users/new-user/schemas/form";

const {
  formField: {
    email,
    nama,
    instansi,
    pangkat,
    jabatan,
    bidang,
    unit,
    status,
    facebook,
    instagram,
    perusahaan,
    nama_user,
    bio,
  },
} = checkout;

const initialValues = {
  [email.name]: "",
  [nama.name]: "",
  [instansi.name]: "",
  [pangkat.name]: "",
  [jabatan.name]: "",
  [bidang.name]: "",
  [unit.name]: "",
  [facebook.name]: "",
  [instagram.name]: "",
  [perusahaan.name]: "",
  [nama_user.name]: "",
  [bio.name]: "",
  [status.name]: "",
};

export default initialValues;
